var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61.977032mm",
    height: "62.201397mm",
    viewBox: "0 0 61.977032 62.201397",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-173.01749,-122.97718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 201.37126,185.06935 c -7.61611,-0.6919 -14.87179,-4.27209 -20.09823,-9.91712 -4.70654,-5.0835 -7.45756,-11.42287 -8.13123,-18.73736 -1.42536,-15.47612 9.55972,-29.90815 25.10421,-32.98152 3.29105,-0.65069 8.67861,-0.59902 11.98885,0.11498 6.06702,1.30861 11.03683,3.99993 15.49784,8.39258 9.4153,9.27103 11.94168,23.60469 6.24139,35.41109 -2.26852,4.69854 -5.11569,8.22708 -9.16127,11.35371 -5.97202,4.61548 -14.10725,7.02993 -21.44156,6.36364 z m 1.50564,-15.47807 c 12.46592,-16.41168 21.12285,-28.08727 20.94352,-28.24649 -0.73883,-0.65599 -6.75909,-5.06976 -6.81404,-4.99573 -0.0366,0.0494 -3.97451,5.26898 -8.75081,11.59914 -4.77631,6.33015 -8.70009,11.53337 -8.71951,11.56269 -0.0194,0.0293 -2.29336,-1.66448 -5.05318,-3.764 -2.75983,-2.09953 -5.09438,-3.82016 -5.18788,-3.82363 -0.0935,-0.003 -1.33611,1.5541 -2.76134,3.46128 -2.02387,2.70827 -2.50808,3.51537 -2.21123,3.68575 0.20905,0.11999 4.07102,3.01056 8.58217,6.42348 4.51114,3.41293 8.27026,6.16568 8.35358,6.11722 0.0833,-0.0485 0.81175,-0.95732 1.61872,-2.01971 z",
    id: "path1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.7a82324a80bb6076b149356d86e0eb39.svg";
export { ForwardRef as ReactComponent };